import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import * as moment from 'moment-timezone';

@Component({
	templateUrl: './save_contact_details.component.html'
})
export class SaveContactDetailsComponent extends InfoModalComponent {
	public moment = moment;

	detailLoader: boolean = false;
	details: any;
	
	ok() {
		this.close();
	}
}
